import React from "react";
import Sidebar from "../components/Sidebar";

export default function AdminLayout({
  title,
  children,
}: {
  readonly title?: string;
  readonly children: React.ReactNode;
}) {
  return (
    <div className="h-screen w-full flex bg-gray-100 overflow-hidden">
      <Sidebar />
      <div className="flex-1 min-h-0 min-w-0 flex flex-col">
        {title && (
          <div className="px-6 py-4 bg-white border-b border-gray-200 flex-shrink-0">
            <h1 className="text-xl font-semibold text-gray-800">{title}</h1>
          </div>
        )}
        <div className="flex-1 min-h-0 overflow-y-auto p-6">{children}</div>
      </div>
    </div>
  );
}
